import { motion } from "framer-motion";
import { TIMELINE } from "@/data/products";

export default function Timeline() {
  return (
    <section className="py-24 lg:py-32 bg-muted/40 overflow-hidden" data-testid="timeline-section">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16 space-y-4">
          <div className="eyebrow">Our Journey</div>
          <h2 className="font-display font-bold text-4xl lg:text-5xl tracking-tighter">
            From Manchester incorporation to <span className="gold-gradient-text">our next chapter.</span>
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-border md:-translate-x-1/2" />
          <div className="space-y-12">
            {TIMELINE.map((item, i) => (
              <motion.div
                key={`${item.year}-${item.title}`}
                initial={{ opacity: 0, x: i % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6 }}
                className={`relative flex flex-col md:flex-row items-start gap-6 ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}
              >
                <div className="ml-12 md:ml-0 md:w-1/2 md:px-8">
                  <div className="bg-background border border-border rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow">
                    <div className="font-display font-black text-4xl gold-gradient-text">{item.year}</div>
                    <div className="font-display font-semibold text-xl mt-2">{item.title}</div>
                    <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
                <div className="absolute left-4 md:left-1/2 top-6 w-3 h-3 rounded-full bg-gold-400 ring-4 ring-background md:-translate-x-1/2" />
                <div className="hidden md:block md:w-1/2" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
